import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesGrid() {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-background-50 to-primary-50/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 border border-foreground-300/40 rounded-full text-[11px] font-semibold text-foreground-500 uppercase tracking-[0.08em] mb-6 whitespace-nowrap">
            15 SEKCJI PRODUKTÓW I PORADNIKÓW
          </span>
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-900 font-bold leading-[1.2] mb-4">
            Wszystko czego potrzebujesz<br />w jednym miejscu
          </h2>
          <p className="text-[16px] text-foreground-500 font-body max-w-[520px] mx-auto">
            Wybierz kategorię i przejdź do pełnej bazy produktów.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-white rounded-2xl overflow-hidden border border-foreground-100/60 hover:border-primary-400 transition-all duration-300 cursor-pointer hover:shadow-lg"
            >
              <div className="relative h-[180px] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2.5 mb-3">
                  <div className="w-8 h-8 rounded-lg bg-foreground-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300">
                    <i className={`${cat.icon} text-base text-foreground-600 group-hover:text-primary-600 transition-colors duration-300`}></i>
                  </div>
                  <h3 className="text-[16px] font-bold text-foreground-900 group-hover:text-primary-700 transition-colors duration-300 font-body whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-[13px] text-foreground-400 mb-4 group-hover:text-foreground-500 transition-colors duration-300 line-clamp-2 leading-relaxed">
                  Najlepsze {cat.name.toLowerCase()} w Kakobuy Spreadsheet — sprawdzone produkty i okazje.
                </p>
                <span className="inline-flex items-center gap-1.5 text-[14px] font-semibold text-foreground-800 group-hover:text-primary-600 transition-all duration-300 whitespace-nowrap">
                  Przejdź
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-300"></i>
                </span>
              </div>
            </a>
          ))}

          <Link
            to="/co-to-jest-kakobuy-sheet"
            className="group bg-white rounded-2xl overflow-hidden border border-foreground-100/60 hover:border-primary-400 transition-all duration-300 cursor-pointer hover:shadow-lg"
          >
            <div className="relative h-[180px] overflow-hidden bg-gradient-to-br from-primary-100 to-primary-50">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-20 h-20 rounded-full bg-white/80 flex items-center justify-center">
                  <i className="ri-book-read-line text-3xl text-primary-500"></i>
                </div>
              </div>
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2.5 mb-3">
                <div className="w-8 h-8 rounded-lg bg-foreground-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300">
                  <i className="ri-book-read-line text-base text-foreground-600 group-hover:text-primary-600 transition-colors duration-300"></i>
                </div>
                <h3 className="text-[16px] font-bold text-foreground-900 group-hover:text-primary-700 transition-colors duration-300 font-body">
                  Co to jest Kakobuy Sheet?
                </h3>
              </div>
              <p className="text-[13px] text-foreground-400 mb-4 group-hover:text-foreground-500 transition-colors duration-300 line-clamp-2 leading-relaxed">
                Kompletny przewodnik po arkuszu Kakobuy — dowiedz się jak działa i jak z niego korzystać.
              </p>
              <span className="inline-flex items-center gap-1.5 text-[14px] font-semibold text-foreground-800 group-hover:text-primary-600 transition-all duration-300 whitespace-nowrap">
                Przeczytaj
                <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-300"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}